exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/** \n* Пагинация =====================================================\n*/\n/**\n* Хлебные крошки\n*/\n.we-did[data-v-f6d785b8] {\n  padding: 80px 0 73px;\n}\n.we-did .we-did__title[data-v-f6d785b8] {\n  margin-bottom: 52px;\n}\n@media screen and (max-width: 767.98px) {\n.work[data-v-f6d785b8]:first-child {\n    margin-bottom: 32px;\n}\n}\n.work .work__link[data-v-f6d785b8],\n.work .work__desc[data-v-f6d785b8] {\n  line-height: 1.5;\n  letter-spacing: 0.2px;\n}\n.work .work__link--border[data-v-f6d785b8] {\n  padding-bottom: 3px;\n  border-bottom: 2px solid #00afa1;\n}", ""]);

// exports
